export enum CustomTableFilterTypeEnum {
  Date = 'date',
  Select = 'select',
  Text = 'text',
}
